import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function RedirectToHomeIfAuthenticated({ children }) {
  const userToken = localStorage.getItem('authToken');
  const location = useLocation();

  if (userToken) {
    // If authenticated, redirect to home
    return <Navigate to="/home" replace state={{ from: location }} />;
  }

  // If not authenticated, render the children components (login or register page)
  return children;
}
